export const environment = {
  production: true,
  schedurl: '/api/schedule',
  authurl: '/api/auth',
  periourl: '/api/perio',
  TDOurl: '/api/',
  DVAPIurl: '/api/DocuViewareREST',
  CurrentPatient: 'F0F6903F-F29E-E711-A59F-6045CB81D461',
  tdoSocketUrl: '',
  tdoxReportingUrlDXXRDV: '/',
  tdoxReportingUrl: '/reporting-service/',
  subdomain: '/referralPortal?token=',
  scheme:  'http://',
  TDOCommsURL: '/commms/',
  lettersUrl: 'https://tdo4endo.com/cloudletters/'
  //'https://wcreporting.tdox.dental/' //https://alphareporting.tdox.dental/ //'https://localhost:44387/'
};
